import $ from 'jquery';
import { init as propertiesForSaleInit } from 'scripts/components/aktiv/aktiv-properties-for-sale-for-search';
import { search as propertiesForSaleSearch } from 'scripts/components/aktiv/aktiv-properties-for-sale-for-search';
import { initSearchTerms } from './aktiv-search-terms';
import { bindSearchElements, mapToModel, mapToEvent, initRadiobox, initCheckboxes, initCityAreas, initMunicipality, initCounties, disableDropdowns, onSliderChange, onRadiobuttonChange, onDropdownChange, onCheckboxChange } from 'scripts/shared/aktiv-search-form-controls';

let translations;
const searchTerms = initSearchTerms();

const inputs = {
  county: mapToModel('county', '#ak-sp-fylke'),
  municipality: mapToModel('municipality', '#ak-sp-kommune'),
  cityArea: mapToModel('cityArea', '#ak-sp-bydeler'),
  facilities: mapToModel('facilities', 'input[name="fasiliteter"]'),
  propertyType: mapToModel('propertyType', 'input[name="eiendom"]'),
  numberOfBedrooms: mapToModel('numberOfBedrooms', 'input[name="radioBedroom"]'),
  area: mapToModel('area', '#ak-sp-sliderStorrelse'),
  price: mapToModel('price', '#ak-sp-sliderPris'),
};

const search = () => {
  $('#property-search-result').empty();
  propertiesForSaleSearch(searchTerms, translations);
};

const bindSlider = (input, model) => {
  $(input.element).on('slideStop', (e) => {
    onSliderChange(e, input, model);
    search();
  });
};

const dropdownProperties = {
  county: {
    toClear: [inputs.municipality, inputs.cityArea],
    toDisable: [inputs.cityArea],
    init: initMunicipality },
  municipality: {
    toClear: [inputs.cityArea],
    init: initCityAreas,
  },
  cityArea: {},
};

const bindDropdown = (input, model) => {
  $(input.element).on('change', (event) => {
    onDropdownChange(input, model, event, dropdownProperties, inputs, translations);
    search();
  });
};

const bindCheckboxes = (input, model) => {
  initCheckboxes(input, model);
  $(input.element).on('change', () => {
    onCheckboxChange(input, model);
    search();
  });
};

const bindRadioButtons = (input, model) => {
  initRadiobox(input, model);
  $(input.element).on('change', () => {
    onRadiobuttonChange(input, model);
    search();
  });
};

const events = {
  county: mapToEvent(inputs.county, bindDropdown),
  municipality: mapToEvent(inputs.municipality, bindDropdown),
  cityArea: mapToEvent(inputs.cityArea, bindDropdown),
  facilities: mapToEvent(inputs.facilities, bindCheckboxes),
  propertyType: mapToEvent(inputs.propertyType, bindCheckboxes),
  numberOfBedrooms: mapToEvent(inputs.numberOfBedrooms, bindRadioButtons),
  area: mapToEvent(inputs.area, bindSlider),
  price: mapToEvent(inputs.price, bindSlider),
};

const getInitModel = () => {
  const model = {
    containerId: 'property-search-result',
    loadMoreId: 'ak-sp-load-more',
    spinnerId: 'ak-sp-loading',
    noHitsId: 'ak-sp-no-hits',
    searchTerms,
    labels: translations,
  };
  return model;
};

const init = (trans) => {
  translations = trans;
  disableDropdowns([inputs.municipality, inputs.cityArea], searchTerms);
  bindSearchElements(searchTerms, inputs, events);
  initCounties(searchTerms.county, inputs, searchTerms, translations);
  propertiesForSaleInit(getInitModel());
};

export { init, searchTerms };
